import { createSelector } from "reselect";

import { getBillingDocuments, getBusinesses } from "../root";
import { getInterestPreviewById } from "../interestPreview";

export interface InterestPreviewAggridRow {
  interestPreview: InterestPreviewData;
  billingDocument?: BillingDocument;
  business?: Business;
}

export const selectInterestPreviewAgGridData = createSelector(
  [getInterestPreviewById, getBillingDocuments, getBusinesses],
  (
    interestPreviewById,
    billingDocuments,
    businesses,
  ): InterestPreviewAggridRow[] =>
    Object.values(interestPreviewById).map(interestPreview => ({
      interestPreview,
      billingDocument: billingDocuments[interestPreview.billingDocumentId],
      business: businesses[interestPreview.businessId],
    })),
);
